// Redux/Slices/user.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  users: [],
  roles: [],
  searchTerm: '',
  currentPage: 1,
  itemsPerPage: 10,
  totalUsers: 0,
  loading: false,
  error: null
};

export const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.users = action.payload.users;
      state.totalUsers = action.payload.total;
    },
    setRoles: (state, action) => {
      state.roles = action.payload.roles;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
      // Reset to first page when searching
      state.currentPage = 1;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    deleteUser: (state, action) => {
      state.users = state.users.filter(user => user.user_id !== action.payload);
      state.totalUsers -= 1;
    }
  }
});

export const {
  setUsers,
  setRoles,
  setCurrentPage,
  setSearchTerm,
  setLoading,
  setError,
  deleteUser
} = userSlice.actions;

export default userSlice.reducer;